<template>
  <div>
    <div class="subtitle has-text-centered has-text-weight-bold">
      {{ title }}
    </div>
    <div class="mt-2">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "SessionRatingQuestionLayout",

  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped></style>
